export default "__VITE_ASSET__Bju4_VG4__"